<template>
  <div>
    <crm-generic
      title="Clientes"
      namespace="customers"
      :defaultEditing="defaultEditing"
      :searchFields="['social_name', 'email']"
      :isAddVisible="true"
      @open-modal="onOpenModal"
      :extras="extras">
      <template v-slot:header>
        <th>Nome</th>
        <!-- <th>E-mail</th>
        <th>Telefone</th> -->
      </template>
      <template v-slot:item="{ item }">
        <td>
          <router-link :to="'/crm/customers/' + item.pk">{{ item.social_name }}</router-link>
        </td>
        <!-- <td>{{ item.email }}</td>
        <td v-if="item.phone">{{ item.phone.phone }}</td>
        <td v-else></td> -->
      </template>
      <template v-slot:fields="{ editingItem }">
        <generic-form :fields="fields" :editing="editingItem"></generic-form>
      </template>
    </crm-generic>
  </div>
</template>
<script>
import CRMGeneric from './CRMGeneric';
import states from '../../utils/states';
import GenericForm from '../../components/GenericForm';

export default {
  components: {
    'crm-generic': CRMGeneric,
    GenericForm,
  },
  data() {
    return {
      isPF: true,
      defaultEditing: {
        social_name: '',
        name: '',
        email: '',
        cep: '',
        address: '',
        address_number: '',
        complement: '',
        district: '',
        city: '',
        uf: '',
        cpf: '',
        rg: '',
        cnh: '',
        cnpj: '',
        ie: '',
        imun: '',
        observation: '',
      },
    }
  },
  computed: {
    fields() {
      const fields = [{
        text: 'Ativo',
        name: 'active',
        type: 'checkbox'
      }, {
        text: this.isPF ? 'Nome Social' : 'Razão social',
        name: 'social_name',
        limit: 100,
        rules: 'required',
      }, {
        text: this.isPF ? 'Nome' : 'Nome fantasia',
        name: 'name',
        limit: 100,
      }, {
        text: 'E-mail',
        name: 'email',
        type: 'email',
      }, {
        text: 'CEP',
        name: 'cep',
        type: 'cep',
      }, {
        text: 'Endereço',
        name: 'address',
      }, {
        text: 'Número',
        name: 'address_number',
        type: 'number',
      }, {
        text: 'Complemento',
        name: 'complement',
      }, {
        text: 'Bairro',
        name: 'district',
      }, {
        text: 'Cidade',
        name: 'city',
      }, {
        text: 'UF',
        name: 'uf',
        options: states
      }, {
          text: 'Observações',
          name: 'observation',
          type: 'textarea'
      }];

      if (this.isPF) {
        fields.push(...[{
          text: 'CPF',
          name: 'cpf',
          //rules: 'required',
          type: 'mask',
          mask: '###.###.###-##',
        }, {
          text: 'RG',
          name: 'rg',
          type: 'mask',
          mask: '##.###.###-#',
        }, {
          text: 'CNH',
          name: 'cnh',
        }]);
      } else {
        fields.push(...[{
          text: 'CNPJ',
          name: 'cnpj',
          //rules: 'required',
          type: 'mask',
          mask: '##.###.###/####-##',
        }, {
          text: 'Inscrição Estadual',
          name: 'ie',
        }, {
          text: 'Inscrição Municipal',
          name: 'imun',
        }]);
      }

      return fields;
    },
    extras() {
      return {
        isPF: this.isPF
      }
    }
  },
  methods: {
    onOpenModal(data) {
      this.isPF = data.is_pf ? data.is_pf : data === 'pf';
    }
  }
}

</script>
